import timeout from '../../js/lib/timeout';
import closeIcon from '../../../images/icons/close.svg';

(function ($, Drupal, once) {
  const utilityComponents = {
    wrapper() {
      return "<div class='ui-dialog-wrapper'></div>";
    },
    skipButton() {
      return `<button class="button btn-tertiary" data-veolia-modal-skip>${Drupal.t(
        'Skip',
      )}</button>`;
    },
    nextButton() {
      return `<button class="button btn-tertiary" data-veolia-modal-next>${Drupal.t(
        'Next',
      )}</button>`;
    },
    closeButton() {
      return `<button class="button btn-tertiary" data-veolia-modal-close>${Drupal.t(
        'Close',
      )}</button>`;
    },
    bullets(currentSlideCount) {
      let bulletsHTML = '<div class="veolia-modal-bullets">';
      for (let i = 0; i < currentSlideCount; i++) {
        if (i === 1) {
          bulletsHTML += `<div class="veolia-modal-bullet active" data-veolia-modal-slide-index="${i}"></div>`;
        } else {
          bulletsHTML += `<div class="veolia-modal-bullet" data-veolia-modal-slide-index="${i}"></div>`;
        }
      }
      bulletsHTML += '</div>';
      return bulletsHTML;
    },
  };

  /**
   * initiating the modal, triggered when the modal is opened
   * @param {object} instance - drupal instance of jquery dialog ui
   * @param {JQuery} $element - content element of the modal
   * @param {object} settings - settings the modal has been initiated with
   */
  function veoliaModal(instance, $element, settings) {
    let currentModalId;
    let currentSlideCount;
    let currentSlideIndex = 0;
    const $dialogContent = $element;
    const $dialog = $element.dialog('widget');
    const dialogInstance = instance;
    const $overlay = $('.ui-widget-overlay');
    const $closeButton = $dialog.find(
      '.ui-dialog-titlebar .ui-button,.ui-dialog-cancel-button',
    );
    let $wrapper = $(utilityComponents.wrapper());
    const $window = $(window);

    /**
     * initiating events
     */
    function initEvents() {
      $dialogContent.on('click', '*[data-veolia-modal-next]', nextSlide);
      $dialogContent.on('click', '*[data-veolia-modal-skip]', beforeClose);
      $dialogContent.on('click', '*[data-veolia-modal-close]', beforeClose);
      $overlay.on('click', beforeClose);
      // removing the default click event to close dialog
      $closeButton.off('click');

      // Do nothing when clicking the close button or cancel buttons.
      // We'll handle later the action.
      $closeButton.click(function (e) {
        e.preventDefault();
      });

      $closeButton.on('click', beforeClose);
      $dialogContent.on(
        'click',
        '*[data-veolia-modal-slide-index]',
        function () {
          goToSlide(parseInt($(this).attr('data-veolia-modal-slide-index')));
        },
      );
      $window.on('keyup', onKeyChange);
      $window.on('dialog:afterclose', afterClose);
    }

    /**
     * create new component and add it to placement
     * @param {string} componentPlacement - where the element should be placed
     * @param {string} componentName - name of the component
     * @param {Array} args - arguments passed to the creation of the component
     */
    function addUtilityComponent(componentPlacement, componentName, ...args) {
      const $componentParent = $(
        `.veolia-modal-utilities-${componentPlacement}`,
      );
      const componentFunction = utilityComponents[componentName];
      $componentParent.css('opacity', '0');

      setTimeout(() => {
        $componentParent.html(componentFunction(args));
        $componentParent.css('opacity', '');
      }, 200);
    }

    /**
     * initiating the custom modal functionality.
     *
     * Wrap and helper component around the ui-dialog,
     * use flex instead of fixed position, so that the content can dynamically
     * change in height. Initiating slider if existing. Animate the modal in.
     */
    async function init() {
      // Move action buttons below modal content.
      // $window.off('dialog:aftercreate', afterCreate);
      const $drupalModal = $('#drupal-modal');
      const $actionButtons = $drupalModal.find('div.form-actions > *');
      const $newButtonPane = $(
        '<div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix"><div class="ui-dialog-buttonset form-actions"></div></div>',
      );
      $newButtonPane.insertAfter($drupalModal);
      $newButtonPane.find('.form-actions').append($actionButtons);

      disableScroll();
      // create container outside to position the dialog correctly,
      // by using flex instead of top and bottom.
      $wrapper = $dialog.wrap($wrapper).parent();

      $dialog.find('.ui-dialog-titlebar').removeClass('ui-helper-clearfix');

      $dialog.find('.ui-dialog-title').addClass('h2');

      $closeButton
        .addClass('btn btn-secondary')
        .removeClass('ui-button-icon-only');

      $closeButton
        .find('.ui-button-icon')
        .addClass('icon')
        .removeClass('ui-icon')
        .html(closeIcon);

      // Make "Close" string translateable.
      $closeButton.each(function () {
        const $button = $(this);
        const $buttonSpanContent = $button.clone().children().wrapAll('div').parent()
          .html();
        const buttonNakedText = $button.clone().remove('*>').text().trim();
        if (buttonNakedText === 'Close') {
          $button.html($buttonSpanContent + Drupal.t('Close'));
        }
      });

      $dialogContent
        .find('.form-submit[data-once="drupal-ajax"]')
        .parents('.form-actions')
        .addClass('hidden');

      // copy dialog custom dialog classes to theme modal;
      $wrapper.addClass(settings.dialogClass);
      if (settings.classes && settings.classes['ui-dialog']) {
        $wrapper.addClass(settings.classes['ui-dialog']);
      }

      currentSlideCount = $dialogContent.find('.veolia-modal-slide').length;

      if (currentSlideCount === 1) {
        addUtilityComponent('right', 'closeButton');
      }

      if (currentSlideCount > 1) {
        addUtilityComponent('left', 'skipButton');
        addUtilityComponent('right', 'nextButton');
      }

      const $nextSlide = $(
        `.veolia-modal-slide:nth-child(${currentSlideIndex + 1}`,
      );
      $nextSlide.addClass('active');

      const nextTheme = $nextSlide.attr('data-modal-theme');
      $dialog.attr('data-modal-theme', nextTheme);

      initEvents();

      $overlay.addClass('active');
      await timeout(50);
      $dialog.addClass('active');
      await timeout(150);
    }

    /**
     * before the modal is closing, fade out animation.
     * @param {Object} evt - jQuery event object
     */
    async function beforeClose(evt) {
      if (evt && evt.type === 'click') {
        evt.preventDefault();
      }

      // Perform action on close based on the settings set on backend
      if (settings.onCloseAction === 'refresh') {
        location.reload();
        return;
      }
      if (
        settings.onCloseAction === 'redirect' &&
        settings.onCloseRedirectURL
      ) {
        window.location.href = settings.onCloseRedirectURL;
        return;
      }

      // Perform action on close based on the settings inline in the "cancel" button
      const $cancelLink = $dialog.find('a[data-on-close-action]');
      const cancelLinkOnCloseAction = $cancelLink.attr('data-on-close-action');
      const cancelLinkOnCloseRedirectURL = $cancelLink.attr('href');
      if (cancelLinkOnCloseAction === 'refresh') {
        location.reload();
        return;
      }
      if (cancelLinkOnCloseAction === 'redirect') {
        window.location.href = cancelLinkOnCloseRedirectURL;
        return;
      }

      $dialog.removeClass('active');
      await timeout(150);
      $overlay.removeClass('active');
      await timeout(600);
      dialogInstance.close();
    }

    /**
     * modal is closed, clean up created things.
     */
    function afterClose() {
      enableScroll();
      currentSlideCount = null;
      currentSlideIndex = 0;
      $wrapper.remove();

      $window.off('keyup', onKeyChange);
      $window.off('dialog:afterclose', afterClose);
    }

    /**
     * when key is pressed
     * @param {KeyboardEvent} event - keyboard event
     */
    function onKeyChange(event) {
      if (event.which === 27) {
        beforeClose();
      } else if (event.which === 39) {
        nextSlide();
      } else if (event.which === 37) {
        prevSlide();
      }
    }

    /**
     * transition to another slide
     * @param {number} slideIndexToGo - number of the slide to show
     */
    function goToSlide(slideIndexToGo) {
      if (slideIndexToGo < currentSlideCount) {
        if ($('.veolia-modal-bullets').length) {
          $('.veolia-modal-bullet.active').removeClass('active');
          $(`.veolia-modal-bullet:nth-child(${slideIndexToGo + 1})`).addClass(
            'active',
          );
        }

        if (slideIndexToGo + 1 === currentSlideCount) {
          addUtilityComponent('right', 'closeButton');
        } else if (!$('.button[data-veolia-modal-next]').length) {
          addUtilityComponent('right', 'nextButton');
        }
        if (slideIndexToGo === 0) {
          addUtilityComponent('left', 'skipButton');
        }
        if (slideIndexToGo === 1 && !$('.veolia-modal-bullets').length) {
          addUtilityComponent('left', 'bullets', currentSlideCount);
        }

        let leaving = 'leftwise';
        let arriving = 'rightwise';
        if (currentSlideIndex > slideIndexToGo) {
          leaving = 'rightwise';
          arriving = 'leftwise';
        }

        $('.ui-dialog-content').attr(
          'data-modal-theme',
          $(`.veolia-modal-slide:nth-child(${slideIndexToGo + 1})`).attr(
            'data-modal-theme',
          ),
        );

        $('.veolia-modal-slide.active').addClass(leaving);
        setTimeout(() => {
          $('.veolia-modal-slide.active')
            .removeClass('active leftwise rightwise')
            .attr('style', '');
          $(`.veolia-modal-slide:nth-child(${slideIndexToGo + 1})`)
            .addClass(arriving)
            .css('display', 'grid');
          setTimeout(() => {
            $(`.veolia-modal-slide:nth-child(${slideIndexToGo + 1})`)
              .addClass('active')
              .removeClass(arriving);
          }, 50);
        }, 300);

        currentSlideIndex = slideIndexToGo;
      } else {
        throw new Error(`There aren't that many slides in ${currentModalId}`);
      }
    }

    /**
     * next slide if available.
     */
    function nextSlide() {
      if (currentSlideIndex < currentSlideCount) {
        goToSlide(currentSlideIndex + 1);
      } else {
        throw new Error('Already on last slide');
      }
    }

    /**
     * show previous slide if available.
     */
    function prevSlide() {
      if (currentSlideIndex > 0) {
        goToSlide(currentSlideIndex - 1);
      } else {
        throw new Error('Already on first slide');
      }
    }

    /**
     * disable document scroll
     */
    function disableScroll() {
      document.body.style.overflow = 'hidden';
    }

    /**
     * enable document scroll
     */
    function enableScroll() {
      document.body.style.overflow = '';
    }

    /**
     * Removes duplicate button panes.
     * @param {jQuery} $context - The context within which to search for button panes.
     */
    function removeDuplicates($context) {
      const $buttonPanes = $context.find('.ui-dialog-buttonpane');

      if ($buttonPanes.length > 1) {
        $buttonPanes.not(':first').remove();
      }
    }

    init();

    removeDuplicates($dialog.parent());
  }

  Drupal.behaviors.veoliaModal = {
    attach: function attach() {
      $(once('dialogCreate', 'html')).each(function () {
        $(window).on(
          'dialog:aftercreate',
          (event, instance, $element, settings) => veoliaModal(instance, $element, settings),
        );
      });
    },
  };

  /**
   * Patching the original function to allow button.
   * Scan a dialog for any primary buttons and move them to the button area.
   *
   * @param {jQuery} $dialog
   *   A jQuery object containing the element that is the dialog target.
   *
   * @return {Array}
   *   An array of buttons that need to be added to the button area.
   */
  Drupal.behaviors.dialog = Drupal.behaviors.dialog || {};
  Drupal.behaviors.dialog.prepareDialogButtons = function ($dialog) {
    if ($dialog.find('.form-actions').length === 0) {
      // Remove buttons only when the actions area has been removed by AJAX.
      $('.ui-dialog-buttonpane', $dialog.parent()).remove();
    }
    return [];
  };
}(jQuery, Drupal, once));
